// no itx for this file

import { ChannelType } from "../../models/ChannelType";
import SignalTypes from "../../models/SignalTypes";
import { NameListEntry } from "../NameEntryList";
import { ruleId } from "../ruleId";

export const actorActions: Array<NameListEntry> = [
  ///////////////////////////////////////////////////////////////////////////////////
  // block the following definitions as action and forward them to status evaluation
  //
  /////////////////////////////////////////////////////////////////////////////////////

  // ABB
  {
    id: ruleId("Actor-Actions-Jalousie-ABB"),
    signalType: SignalTypes.BlindPosition,
    functionNames: ["move "],
    excludeFunctionNames: ["louvres", "slat"],
    dpts: ["@ 1 byte", "dpst-5-1"],
    manufacturers: ["m-0002"],
  },
  {
    id: ruleId("Actor-Actions-Slat-ABB"),
    signalType: SignalTypes.SlatPosition,
    functionNames: ["move slat", "position slat"], // //
    dpts: ["@ 1 byte", "dpst-5-1"],
    manufacturers: ["m-0002"],
  },
  {
    id: ruleId("Actor-Actions-Logic-ABB"),
    signalType: SignalTypes.Switch,
    functionNames: ["logic"],
    dpts: undefined,
    manufacturers: ["m-0002"],
  },
  {
    id: ruleId("Actor-Actions-Logic2-ABB"),
    signalType: SignalTypes.Ignored,
    texts: ["logic"],
    dpts: ["dpst-5"], // for now no support for thresholh values
    manufacturers: ["m-0002", "m-0083"],
  },
  {
    id: ruleId("Actor-Actions-Ignore1-ABB"),
    signalType: SignalTypes.Ignored,
    functionNames: ["time", "shedding", "forced", "sun", "priorit", "limitation"],
    dpts: undefined,
    manufacturers: ["m-0002"],
  },
  {
    id: ruleId("Actor-Actions-Ignore2-ABB"),
    signalType: SignalTypes.Ignored,
    texts: ["time", "shedding", "forced", "sun", "priorit", "limitation"],
    dpts: undefined,
    manufacturers: ["m-0002"],
  },

  //////////////////////////////////////////////////////////////
  // Merten M-000C

  // send to status
  {
    id: ruleId("Actor-Actions-Unknown-Merten"),
    signalType: SignalTypes.Unknown,
    functionNames: ["checkback"],
    dpts: undefined,
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Actions-Error2-Merten"),
    signalType: SignalTypes.Unknown,
    functionNames: ["short-circuit"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Actions-Error3-Merten"),
    signalType: SignalTypes.Unknown,
    functionNames: ["reached"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },

  // // logic ?? inerhal eines schalt channel 	Blind/Switch actuator REG-K/12x/24x/10 with manual 649912
  {
    id: ruleId("Actor-Actions-Logic-Ignored-Merten"),
    signalType: SignalTypes.Ignored,
    texts: ["logic"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Actions-Logic-Ignored1-Merten"),
    signalType: SignalTypes.Ignored,
    texts: ["live-signal"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Actions-ValveState-Ignore-Merten"),
    signalType: SignalTypes.Ignored,
    texts: ["all valves closed"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Actions-ValveState-Ignore2-Merten"),
    signalType: SignalTypes.Ignored,
    texts: ["locking 2"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },

  // heating

  {
    id: ruleId("Actor-Actions-ValveState-Ignore3-Merten"),
    signalType: SignalTypes.Temperature_ControlValue,
    texts: ["heating continuous"],
    excludeTexts: ["response"],
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"],
  },

  // jal
  {
    id: ruleId("Actor-Actions-Jal-Merten"),
    signalType: SignalTypes.BlindStopStep,
    texts: ["stop/step", "stop"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Actions-Jal2-Merten"),
    signalType: SignalTypes.BlindMove,
    texts: ["movement"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Actions-Jal3-Merten"),
    signalType: SignalTypes.BlindPosition,
    texts: ["height"],
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Actions-Jal4-Merten"),
    signalType: SignalTypes.SlatPosition,
    texts: ["slat position"],
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"],
  },
  // dim
  {
    id: ruleId("Actor-Actions-Dimming-Merten"),
    signalType: SignalTypes.DimValue,
    texts: ["value"],
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Actions-Dimming2-Merten"),
    signalType: SignalTypes.DimStep,
    texts: ["dimming"],
    dpts: ["@ 4 bit"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Actions-Dimming4-Merten"),
    signalType: SignalTypes.DimStep,
    functionNames: ["dimming"],
    dpts: ["@ 4 bit"],
    manufacturers: ["m-000c", "m-0064"],
  },

  // alarm
  {
    id: ruleId("Actor-Actions-alarm-Merten"),
    signalType: SignalTypes.Unknown,
    texts: ["alarm"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },

  // heating
  {
    id: ruleId("Actor-Actions-heating3-Merten"),
    signalType: SignalTypes.Temperature_ControlValue,
    texts: ["valve"],
    functionNames: ["command value"], // 	MEG6730-0001
    dpts: ["dpst-5-1"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Actions-heating2-Merten"),
    signalType: SignalTypes.Temperature_ValveState,
    functionNames: ["value closed"], // 	MEG6730-0001
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Actions-heating4-Merten"),
    signalType: SignalTypes.Temperature_Target,
    functionNames: ["command value", "temperature value"], // 	MEG6003-0006
    dpts: [" @ 2 bytes"],
    manufacturers: ["m-000c", "m-0064"],
  },

  {
    id: ruleId("Actor-Actions-Lock-MertenGira"),
    signalType: SignalTypes.Lock,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["disabling"], //
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064", "m-0008"],
  },
  {
    id: ruleId("Actor-Actions-Lock-Merten"),
    signalType: SignalTypes.Lock,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    texts: ["lock"], //
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },

  /////////////////////////////////////////////////////////////////////////////
  // Hager M-0009

  // send to status
  {
    id: ruleId("Actor-Actions-unknown-Hager"),
    signalType: SignalTypes.Unknown,
    texts: ["info"], // Hager TYB673A
    functionNames: ["info"], // Hager TYB673A
    dpts: ["dpst-1-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  // RGB
  {
    id: ruleId("Actor-Actions-RGB1-Hager"),
    signalType: SignalTypes.RGBRedSwitch,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    texts: ["ch r"], // Hager TYB673A
    functionNames: ["switching"], // Hager TYB673A
    dpts: ["dpst-1-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Actions-RGB2-Hager"),
    signalType: SignalTypes.RGBRedStep,
    texts: ["ch r"], // Hager TYB673A
    functionNames: ["dimming"], // Hager TYB673A
    dpts: ["dpst-3-7"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },

  {
    id: ruleId("Actor-Actions-RGB3-Hager"),
    signalType: SignalTypes.RGBRedValue,
    texts: ["ch r"], // Hager TYB673A
    functionNames: ["value"], // Hager TYB673A
    dpts: ["dpst-5-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Actions-RGB4-Hager"),
    signalType: SignalTypes.RGBGreenSwitch,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    texts: ["ch g"], // Hager TYB673A
    functionNames: ["switching"], // Hager TYB673A
    dpts: ["dpst-1-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Actions-RGB5-Hager"),
    signalType: SignalTypes.RGBGreenStep,
    texts: ["ch g"], // Hager TYB673A
    functionNames: ["dimming"], // Hager TYB673A
    dpts: ["dpst-3-7"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Actions-RGB6-Hager"),
    signalType: SignalTypes.RGBGreenValue,
    texts: ["ch g"], // Hager TYB673A
    functionNames: ["value"], // Hager TYB673A
    dpts: ["dpst-5-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Actions-RGB7-Hager"),
    signalType: SignalTypes.RGBBlueSwitch,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    texts: ["ch b"], // Hager TYB673A
    functionNames: ["switching"], // Hager TYB673A
    dpts: ["dpst-1-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Actions-RGB8-Hager"),
    signalType: SignalTypes.RGBBlueStep,
    texts: ["ch b"], //// Hager TYB673A
    functionNames: ["dimming"], // Hager TYB673A
    dpts: ["dpst-3-7"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Actions-RGB9-Hager"),
    signalType: SignalTypes.RGBBlueValue,
    texts: ["ch b"], //// Hager TYB673A
    functionNames: ["value"], // Hager TYB673A
    dpts: ["dpst-5-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Actions-RGB10-Hager"),
    signalType: SignalTypes.RGBStep,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["relative setvalue control rgb"], // Hager TYB673A
    dpts: ["dpst-3-7"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },

  ///////////////////////////////////////////////////////////////////////////////

  {
    id: ruleId("Actor-Actions-ignore-unknown"), // no itx
    signalType: SignalTypes.Ignored,
    texts: ["standby"],
    dpts: ["dpst-1-1"],
  },

  {
    id: ruleId("Actor-Actions-ignore-soft-switch"), // no itx
    signalType: SignalTypes.Ignored,
    functionNames: [
      "soft switch", //  Soft Switching for Theben 4940285
      "time limited toggle switch", // Hager TXA207A - a2
    ],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-ignore-dimming-value-limit"), // no itx
    signalType: SignalTypes.Ignored,
    functionNames: [
      "dimming value limit", //  Soft Switching for Theben 4940285
    ],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-ignore-errors"), // no itx
    signalType: SignalTypes.Ignored,
    texts: [/gen\. error/, /mains error/, /overload error/, /eis1.*meter/, /announce/],
    dpts: ["dpst-1-1"],
  },

  // Heat Alarm
  {
    id: ruleId("Actor-Actions-HeatAlarm"),
    signalType: SignalTypes.EnvironmentHeatAlarm,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: [
      "heat alarm", //MDT Tempeature Regler UP
    ],
    dpts: ["dpst-1-1"],
  },
  // Frost Alarm
  {
    id: ruleId("Actor-Actions-FrostAlarm"),
    signalType: SignalTypes.EnvironmentFrostAlarm,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: [
      "frost alarm", //MDT Tempeature Regler UP
    ],
    dpts: ["dpst-1-1"],
  },

  {
    id: ruleId("Actor-Actions-block-alarm"),
    signalType: SignalTypes.Unknown,
    functionNames: [
      "alarm", //  abb 2CDG 110 129 R0011
    ],
    dpts: ["dpst-1-1"],
  },
  // ignore

  // ignore
  {
    id: ruleId("Actor-Actions-Dummy1"),
    signalType: SignalTypes.Ignored,
    texts: ["dummy"],
    dpts: undefined, // ABB 2CDG 110 079 R0011
  },

  {
    id: ruleId("Actor-Actions-Dummy2"),
    signalType: SignalTypes.Ignored,
    functionNames: ["dummy"],
    dpts: undefined, // ABB 2CDG 110 079 R0011
  },

  {
    id: ruleId("Actor-Actions-Ignore1"),
    signalType: SignalTypes.Ignored,
    texts: ["reset", "pump - output"], //   ,  Jung 2336REGHZB
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-Ignore2"),
    signalType: SignalTypes.Ignored,
    functionNames: [
      "move to position",
      "enable shading",
      "teach-in",
      "priorit",
      "slave", // abb 2CDG 110 025 R0011
      "ballasts", //abb 2CDG 110 025 R0011
    ], //teach in ->AKD-0324V.02(for white balance)
    dpts: ["dpst-1-1"], // JAL-0810M.02
  },
  {
    id: ruleId("Actor-Actions-EnvironmentError"),
    signalType: SignalTypes.EnvironmentError,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: [
      "fault", //2CDG 110 059 R0011 Störung
      "error", //2CDG 110 074 R0011 Fehlermeldung
      "excess temperature", //2CDG 110 074 R0011 Übertemperatur
      "failure", // abb 2CDG 110 058 R0011
    ], //teach in ->AKD-0324V.02(for white balance)
    dpts: ["dpst-1-1"], // JAL-0810M.02
  },
  {
    id: ruleId("Actor-Actions-Ignore3"),
    signalType: SignalTypes.Ignored, // SignalTypes.Control,
    functionNames: ["control"], // //JAL-01UP.02
    dpts: ["dpst-1-8", "dpst-1-10", "dpst-1-17"], //JAL-01UP.02 // //
  },
  {
    id: ruleId("Actor-Actions-Ignore4"),
    signalType: SignalTypes.Ignored,
    texts: ["error"], //Jung 3904EBLED
    dpts: ["dpst-1-2"], //Jung 3904EBLED
  },

  // blind
  {
    id: ruleId("Actor-Actions-Jalousie1"),
    signalType: SignalTypes.SlatPosition,
    functionNames: [
      "position of slats",
      "slat position",
      "slat angle",
      "position lamelle",
      "positionierung lamelle",
      "slat - position",
    ], //JAL-01UP.02
    excludeFunctionNames: ["indication"],
    dpts: ["dpst-5-1"], //JAL-01UP.02
  },
  {
    id: ruleId("Actor-Actions-Jalousie1,2"),
    signalType: SignalTypes.BlindMove,
    functionNames: ["slat adj"], //6196/82-102(Busch Jäger)( div other from Busch Jäger and ABB)
    excludeFunctionNames: ["stop"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-shutter3-abb"),
    signalType: SignalTypes.SlatPosition,
    functionNames: ["adjust", "move slats"],
    dpts: ["dpst-5-1", "@ 1 byte"],
    manufacturers: ["m-0002"],
  },
  {
    id: ruleId("Actor-Actions-shutter4-abb"),
    signalType: SignalTypes.SlatPosition,
    texts: ["adjust", "move slats"],
    dpts: ["dpst-5-1", "@ 1 byte"],
    manufacturers: ["m-0002"],
  },

  {
    id: ruleId("Actor-Actions-shutter5"),
    signalType: SignalTypes.SlatPosition,
    functionNames: ["position lamelle"],
    dpts: ["@ 1 byte", "dpst-5-1"],
  },

  {
    id: ruleId("Actor-Actions-Jalousie2"),
    signalType: SignalTypes.BlindStopStep,
    functionNames: ["slats adjustment", "up", "down", "slat adj. open/close"], //JAL-0810M.02 // //
    dpts: ["dpst-1-7", "dpst-1-9"], //JAL-0810M.02 //AKU-02UP.03
  },
  {
    id: ruleId("Actor-Actions-Jalousie3"),
    signalType: SignalTypes.BlindStopStep,
    functionNames: ["stop"], // JAL-01UP.02 JAL-0810M.02
    excludeTexts: ["heating"],
    dpts: ["dpst-1-7", "dpst-1-1"], //JAL-01UP.02 JAL-0810M.02
  },
  {
    id: ruleId("Actor-Actions-Jalousie4"),
    signalType: SignalTypes.BlindStartRefDrive,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["time measurement"],
    dpts: ["dpst-1-10"],
  },

  // GIRA
  // Schaltaktor 16fach / Jalousieaktor 8fach 16A REG
  // 1038 00
  {
    id: ruleId("Actor-Actions-Jalousie5"),
    signalType: SignalTypes.BlindPosition,
    functionNames: [
      "blind position",
      "position of blind",
      "awning position", //jung 2504REGHER
      "position blind", //jung 2504REGHE
    ],
    objectSize: "1 byte",
  },
  {
    id: ruleId("Actor-Actions-Jalousie6"),
    signalType: SignalTypes.SlatPosition,
    functionNames: [
      "slat position",
      "position of slat",
      "position slat", //jung 2504REGHE
    ],
    objectSize: "1 byte",
  },

  // end GIRA

  // shutter
  // {
  //   id: ruleId("Actor-Actions-Blind1"),
  //   signalType: SignalTypes.BlindMove,
  //   functionNames: ["stop"], // JAL-01UP.02 JAL-0810M.02
  //   dpts: ["dpst-1-8"], //JAL-01UP.02 JAL-0810M.02//AKU-02UP.03
  // },
  {
    id: ruleId("Actor-Actions-Blind2"),
    signalType: SignalTypes.BlindStopStep,
    functionNames: ["stop"], // AKU-02UP.03
    dpts: ["dpst-1-17", "dpst-1-8"], //AKU-02UP.03
  },
  {
    id: ruleId("Actor-Actions-Blind2_1"), //??
    signalType: SignalTypes.BlindStopStep,
    texts: ["louvre"],
    dpts: ["dpst-1-8"],
  },
  {
    id: ruleId("Actor-Actions-Blind3"),
    signalType: SignalTypes.BlindStartRefDrive,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["start reference drive", "reference movement"], // JAL-01UP.02
    dpts: ["dpst-1-8"], // JAL-01UP.02
  },

  // GIRA   Schaltaktor 16fach / Jalousieaktor 8fach 16A REG
  {
    id: ruleId("Actor-Actions-Blind4a"),
    signalType: SignalTypes.BlindMove,
    functionNames: ["long-time operation", "long time operation", "langzeitbetrieb"], // //jung 2424REGHE // berker ist nur auf deutsch !!
    dpts: ["dpst-1-1", "dpst-1-7", "dpst-1-9"],
  },
  {
    id: ruleId("Actor-Actions-Blind4a_2"),
    signalType: SignalTypes.BlindMove,
    texts: [/move control/],
    functionNames: [/up.*down/, /down.*up/],
    dpts: ["dpst-1-8"],
  },
  {
    id: ruleId("Actor-Actions-Blind4b"),
    signalType: SignalTypes.BlindMove,
    texts: ["up/down"],
    dpts: ["dpst-1-8"],
  },

  {
    id: ruleId("Actor-Actions-Blind4"),
    signalType: SignalTypes.BlindStopStep,
    functionNames: ["operation", "kurzzeitbetrieb"], //// berker ist nur auf deutsch !!
    dpts: ["dpst-1-1", "dpst-1-7", "dpst-1-9"], // // //
  },
  {
    id: ruleId("Actor-Actions-Blind5"),
    signalType: SignalTypes.BlindMove,
    functionNames: ["down/up", "down / up", "up/down", "up / down", "operation", "move"], //JAL-01UP.02 JAL-0810M.02 // //JAL-0810M.02
    excludeFunctionNames: ["hour", "move to position"],
    dpts: ["dpst-1-8", "dpst-1-1"], //JAL-01UP.02  JAL-0810M.02// JAL-0810M.02
  },
  {
    id: ruleId("Actor-Actions-Blind5_1"),
    signalType: SignalTypes.BlindMove,
    functionNames: ["down/up", "down / up", "up/down", "up / down"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-Blind6"),
    signalType: SignalTypes.BlindMoveDown,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["down"], //
    dpts: ["dpst-1-11"], //
  },
  {
    id: ruleId("Actor-Actions-Blind7"),
    signalType: SignalTypes.BlindMoveUp,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["up"], //
    dpts: ["dpst-1-11"], //
  },
  {
    id: ruleId("Actor-Actions-8"),
    signalType: SignalTypes.BlindPosition,
    functionNames: ["position"], //JAL-01UP.02 JAL-0810M.02
    excludeFunctionNames: ["lamelle", "indication"],
    dpts: ["dpst-5-1"], //JAL-01UP.02 JAL-0810M.02
  },

  {
    id: ruleId("Actor-Actions-Blind9"),
    signalType: SignalTypes.BlindPosition,
    texts: ["set position"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-Blind9_2"),
    signalType: SignalTypes.BlindPosition,
    texts: ["shutter - percentage control"],
    functionNames: [/top.*bottom/, /bottom.*top/],
    dpts: ["dpst-5-1"],
  },

  {
    id: ruleId("Actor-Actions-Blind10"),
    signalType: SignalTypes.SlatPosition,
    texts: ["set louvre"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-Blind10_2"),
    signalType: SignalTypes.SlatPosition,
    texts: ["shutter - slats percentage control"],
    functionNames: [/open.*closed/, /closed.*open/],
    dpts: ["dpst-5-1"],
  },

  // Heating
  {
    id: ruleId("Actor-Actions-Heating1_C"),
    signalType: SignalTypes.Temperature_TargetComfort,
    functionNames: ["comfort setpoint", "setpoint comfort"], //SCN-RT8REG.02 //SCN-RT8REG.02
    excludeFunctionNames: ["value", "current"],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Actor-Actions-Heating1_C2"),
    signalType: SignalTypes.Temperature_TargetComfort,
    texts: ["comfort setpoint", "setpoint comfort"], //SCN-RTR60O.01
    excludeFunctionNames: ["value", "current"],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Actor-Actions-Heating1"),
    signalType: SignalTypes.Temperature_Target,
    functionNames: ["setpoint"],
    excludeFunctionNames: ["value", "current"],
    excludeTexts: ["current"], //SCN-RTR60O.01
    dpts: ["dpst-9-1"],
  },

  {
    id: ruleId("Actor-Actions-Heating2"),
    signalType: SignalTypes.Temperature_Min,
    functionNames: ["min"], //AKH-0400.03
    excludeFunctionNames: ["dim"],
    dpts: ["dpst-5-1"], //AKH-0400.03
  },
  {
    id: ruleId("Actor-Actions-Heating3"),
    signalType: SignalTypes.Temperature_Max,
    texts: ["max"], //AKH-0400.03
    dpts: ["dpst-5-1"], //AKH-0400.03
  },
  {
    id: ruleId("Actor-Actions-Heating4"),
    signalType: SignalTypes.Temperature_Min,
    texts: ["min"], //AKH-0400.03
    excludeFunctionNames: ["dim", "brightness"], // // jung	2194REGHM
    excludeTexts: ["dim", "brightness"], // // jung	2194REGHM
    dpts: ["dpst-5-1"], //AKH-0400.03
  },
  {
    id: ruleId("Actor-Actions-Heating5"),
    signalType: SignalTypes.Temperature_Max,
    functionNames: ["max"], //AKH-0400.03
    dpts: ["dpst-5-1"], //AKH-0400.03
  },

  {
    id: ruleId("Actor-Actions-heating10"),
    signalType: SignalTypes.Temperature_ControlValue,
    functionNames: ["control value"],
    dpts: ["dpst-5-1"], // //
  },
  {
    id: ruleId("Actor-Actions-heating10-a"),
    signalType: SignalTypes.Temperature_ControlValue,
    texts: ["control value"], // Siemens 5WG1605-1DB41
    dpts: ["dpst-5-1"], // //
  },
  {
    channelType: [ChannelType.Heating],
    id: ruleId("Actor-Actions-heating10-1"),
    signalType: SignalTypes.Temperature_ControlValue,
    functionNames: ["value"],
    excludeFunctionNames: ["current", "dimming", "brightness"],
    // excludeTexts: ["- output"], //?????????????????????????
    dpts: ["dpst-5-1"], // //
  },

  {
    id: ruleId("Actor-Actions-heating11"),
    signalType: SignalTypes.Temperature_ValveState,
    functionNames: ["control value", "pump on/off"], // MDT AKH 0600.x   , "heating request"
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-heating11_1"),
    signalType: SignalTypes.Temperature_ValveState,
    functionNames: ["= close valve", "= open valve"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-heating12"),
    signalType: SignalTypes.Temperature_ValveState,
    texts: ["valve output"], // Jung 	2336REGHZB
    excludeFunctionNames: [" hours"], // merten MEG6730-0001
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-Heating6"),
    signalType: SignalTypes.Temperature_Current,
    functionNames: [
      "measured",
      "input control",
      "control",
      "value",
      /receive.*temp/, // Albrecht Jung 2336REGHZRHE
    ],
    excludeFunctionNames: ["set", "setpoint"],
    excludeTexts: ["outside"], //
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Actor-Actions-Heating6_2"),
    signalType: SignalTypes.Temperature_Current,
    functionNames: ["actual temp. not adj"], //jung 2178
    dpts: ["@ 2 bytes"],
  },

  {
    id: ruleId("Actor-Actions-Heating7_2"),
    signalType: SignalTypes.Temperature_Target,
    functionNames: ["actual temperature"], //jung 2178
    dpts: ["@ 2 bytes"],
  },
  {
    id: ruleId("Actor-Actions-Heating8"),
    signalType: SignalTypes.Temperature_TargetShift_9,
    functionNames: ["shift"], // //
    excludeFunctionNames: ["value", "current", "status"],
    dpts: ["dpst-9-2", "@ 2 bytes", "dpst-9-1"], //jung 2178
  },
  {
    id: ruleId("Actor-Actions-Heating8a"),
    signalType: SignalTypes.Temperature_TargetShift_6,
    functionNames: ["shift"], // //
    excludeFunctionNames: ["value", "current", "status"],
    dpts: ["dpst-6-10"],
  },
  {
    id: ruleId("Actor-Actions-Heating9"),
    signalType: SignalTypes.Temperature_TargetStep_1,
    functionNames: ["setpoint", "actuating variable"], // // Jung 	2178
    dpts: ["dpst-1-7", "dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-Heating_-Mode-C"),
    signalType: SignalTypes.OperationMode_Comfort,
    functionNames: ["comfort operating mode", "mode comfort"], // MDT
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-Heating_-Mode-C_2"),
    signalType: SignalTypes.OperationMode_Comfort,
    texts: ["special mode: comfort"], // MDT
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-Heating_-Mode-N"),
    signalType: SignalTypes.OperationMode_Night,
    functionNames: ["night operating mode", "mode night"], // MDT
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-Heating_-Mode-N_2"),
    signalType: SignalTypes.OperationMode_Night,
    texts: ["special mode: economy"], // MDT
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-Heating_-Mode-F"),
    signalType: SignalTypes.OperationMode_FrostProtection,
    functionNames: ["frost protection"], // MDT
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-Heating_-Mode-H"),
    signalType: SignalTypes.OperationMode_HeatProtection,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["heat protection"], // MDT
    dpts: ["dpst-1-1"],
  },

  // Hager 	TX206H
  {
    id: ruleId("Actor-Actions-Heating"),
    signalType: SignalTypes.Temperature_ControlValue,
    functionNames: ["%"],
    dpts: ["@ 1 byte"],
    channelType: [ChannelType.Heating],
  },
  {
    id: ruleId("Actor-Actions-Heating"),
    signalType: SignalTypes.Temperature_ValveState,
    functionNames: ["on/of"],
    dpts: ["1-1"],
    channelType: [ChannelType.Heating],
  },

  //RGBW

  {
    id: ruleId("Actor-Actions-RGBW1_5"),
    signalType: SignalTypes.RGBWhiteStep,
    functionNames: [/hsv.* relative.*white/],
    dpts: ["dpst-3-7"],
  },
  {
    id: ruleId("Actor-Actions-RGBW1_5"),
    signalType: SignalTypes.RGBWhiteValue,
    functionNames: [/hsv.* value.*white/],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-RGBW1_3"),
    signalType: SignalTypes.RGBWhiteValue,
    functionNames: ["absolute dimming w"], //Jung 	3904EBLED
    dpts: ["dpst-5-1"], //Jung 	3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGBW1_4"),
    signalType: SignalTypes.RGBWhiteStep,
    functionNames: ["relative dimming w"], //Jung 	3904EBLED
    dpts: ["dpst-3-7"], //Jung 	3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGBW1"),
    signalType: SignalTypes.HSV_HueValue,
    functionNames: ["absolute", "value"], //AKD-0324V.02
    texts: ["hsv hue", "(hue)"], //AKD-0324V.02
    dpts: ["dpst-5-3"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGBW1_2"),
    signalType: SignalTypes.HSV_HueValue,
    functionNames: ["absolute dimming h", "dimming absolute h", /hsv.*set.*hue/, "colour hue (h) - setting"], //jung 3904EBLED
    dpts: ["dpst-5-3"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGBW2"),
    signalType: SignalTypes.DimValue, // SignalTypes.HSV_BrightnessValue,
    functionNames: ["absolutely"], //AKD-0324V.02
    texts: ["hsv brightness"], //AKD-0324V.02
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGBW2_2"),
    signalType: SignalTypes.DimValue, //SignalTypes.HSV_BrightnessValue,
    functionNames: ["absolute dimming v", "dimming absolute v"], //jung 3904EBLED
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGBW3"),
    signalType: SignalTypes.HSV_SaturationValue,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["absolutely"], //AKD-0324V.02
    texts: ["hsv saturation"], //AKD-0324V.02
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGBW3_2"),
    signalType: SignalTypes.HSV_SaturationValue,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["absolute dimming s", "dimming absolute s", /set.*hsv.*saturation/, "saturation (s) - setting"], //jung 3904EBLED
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGBW3_3"),
    signalType: SignalTypes.HSV_SaturationValue,
    texts: [/hsv.*saturation/],
    functionNames: [/value/],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-RGBW4"),
    signalType: SignalTypes.HSV_HueStep,
    functionNames: ["relative"], //AKD-0324V.02
    texts: ["hsv hue", "hue"], //AKD-0324V.02
    dpts: ["dpst-3-7"], //AKD-0324V.02
  },
  //   {
  //   id: ruleId("Actor-Actions-RGBW4"),
  //   signalType: SignalTypes.HSV_HueValueRelative,
  //   functionNames: ["relative"],
  //   texts: ["hsv hue", "hue"],
  //   dpts: ["dpst-5-3"],
  // },
  {
    id: ruleId("Actor-Actions-RGBW4_2"),
    signalType: SignalTypes.HSV_HueStep,
    functionNames: ["relative dimming h", "dimming relative h"], //jung 3904EBLED
    dpts: ["dpst-3-7"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGBW5_1"),
    signalType: SignalTypes.DimStep, //SignalTypes.HSV_BrightnessStep,
    functionNames: ["relatively"], //AKD-0324V.02
    texts: ["hsv brightness"], //AKD-0324V.02
    dpts: ["dpst-3-7"], // //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGBW5_2"),
    signalType: SignalTypes.DimValue, //HSV_BrightnessValue,
    functionNames: ["relatively"], //AKD-0324V.02
    texts: ["hsv brightness"], //AKD-0324V.02
    dpts: ["dpst-5-1"], // //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGBW5_3"),
    signalType: SignalTypes.DimStep, //SignalTypes.HSV_BrightnessStep,
    functionNames: ["relative dimming v", "dimming relative v", /hsv.*relative.*brightness/], //jung 3904EBLED
    dpts: ["dpst-3-7"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGBW6_1"),
    signalType: SignalTypes.HSV_SaturationStep,
    functionNames: ["relative"], //AKD-0324V.02
    texts: ["hsv saturation", "saturation"], //AKD-0324V.02
    dpts: ["dpst-3-7"], //AKD-0324V.02
  },

  {
    id: ruleId("Actor-Actions-RGBW6_2"),
    signalType: SignalTypes.HSV_SaturationValue,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["relatively", "absolute"], //AKD-0324V.02
    texts: ["hsv saturation", "saturation"], //AKD-0324V.02
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGBW6_3"),
    signalType: SignalTypes.HSV_SaturationStep,
    functionNames: ["relative dimming s", "dimming relative s"], //jung 3904EBLED
    dpts: ["dpst-3-7"], //jung 3904EBLED
  },

  // HSV
  {
    id: ruleId("Actor-Actions-HSV1"),
    signalType: SignalTypes.HSV_ColorValue,
    texts: ["hsv"], //AKD-0324V.02
    excludeFunctionNames: ["state"], //AKD-0324V.02
    dpts: ["dpst-232-600"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-HSV1_3"),
    signalType: SignalTypes.HSV_ColorValue,
    texts: ["hsv"],
    functionNames: ["color setting"],
    dpts: ["@ 3 bytes"], //AKD-0424R.02
  },

  {
    id: ruleId("Actor-Actions-HSV2"),
    signalType: SignalTypes.HSVStep,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["dimming relative hsv"], //Enertex Bayern GmbH 1174-DK
    dpts: ["dpst-254-600"], //Enertex Bayern GmbH 1174-DK
  },

  // RGB
  {
    id: ruleId("Actor-Actions-RGB1_1"),
    signalType: SignalTypes.RGBValue,
    texts: ["rgb"], //AKD-0324V.02
    excludeFunctionNames: ["state", "hsv"], //AKD-0324V.02, jung 	3904EBLED
    dpts: ["dpst-232-600", "@ 3 bytes"], //AKD-0324V.02
  },
   {
    id: ruleId("Actor-Actions-RGB1_1_0"),
    signalType: SignalTypes.RGBValue,
    functionNames: ["rgb"], //Gira Dali GW 211100
    excludeFunctionNames: ["state", "hsv"], //Gira Dali GW 211100
    dpts: ["dpst-232-600"], //Gira Dali GW 211100
  },
  {
    id: ruleId("Actor-Actions-RGB1_1_2"),
    signalType: SignalTypes.RGBValue,
    dpts: ["dpst-232-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGB1_4"),
    signalType: SignalTypes.RGBValue,
    texts: ["absolute dimming rgb", "dimming absolute rgb"], //jung 	3904EBLED //Enertex Bayern GmbH 1174-DK
    dpts: ["@ 3 bytes", "dpst-232-600"], //jung 	3904EBLED //Enertex Bayern GmbH 1174-DK
  },
  {
    id: ruleId("Actor-Actions-RGB1_2_3"),
    signalType: SignalTypes.RGBValue,
    functionNames: ["absolute dimming rgb", "dimming absolute rgb"], //jung 	3904EBLED //Enertex Bayern GmbH 1174-DK
    dpts: ["dpst-232-600"], //Enertex Bayern GmbH 1174-DK
  },
  {
    id: ruleId("Actor-Actions-RGB1_3"),
    signalType: SignalTypes.RGBValue6Byte,
    dpts: ["dpst-251-600"],
  },
  {
    id: ruleId("Actor-Actions-RGB1_3"),
    signalType: SignalTypes.RGBRelative_Control254_600,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["absolute relative rgb", "dimming relative rgb"], //Enertex Bayern GmbH 1174-DK
    dpts: ["dpst-254-600"], //Enertex Bayern GmbH 1174-DK
  },
  {
    id: ruleId("Actor-Actions-RGB1"),
    signalType: SignalTypes.HSVValue,
    texts: ["hsv"], //AKD-0324V.02
    excludeFunctionNames: ["state"], //AKD-0324V.02
    dpts: ["dpst-232-600"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGB1_5"),
    signalType: SignalTypes.HSVValue,
    functionNames: ["absolute dimming hsv", "dimming absolute hsv", "brightness (v) - setting"], //jung 	3904EBLED// Enertex Bayern GmbH 1174-DK
    dpts: ["@ 3 bytes", "dpst-232-600"], //jung 	3904EBLED //Enertex Bayern GmbH 1174-DK
  },

  {
    id: ruleId("Actor-Actions-RGB2"),
    signalType: SignalTypes.RGBRedSwitch,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["on/off"], //AKD-0324V.02
    texts: ["red"], //AKD-0324V.02
    dpts: ["dpst-1-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGB3"),
    signalType: SignalTypes.RGBRedStep,
    functionNames: ["relative"], //AKD-0324V.02
    texts: ["red"], //AKD-0324V.02
    dpts: ["dpst-3-7"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGB3_1_BES"),
    signalType: SignalTypes.RGBRedStep,
    functionNames: ["dimming"],
    texts: ["red"],
    dpts: ["dpst-3-7"],
    manufacturers: ["m-009e"], //Bes
  },
  {
    id: ruleId("Actor-Actions-RGB3_4_BES"),
    signalType: SignalTypes.RGBRedValue,
    functionNames: ["value"],
    texts: ["red"],
    dpts: ["dpst-5-1"],
    manufacturers: ["m-009e"], //Bes
  },

  {
    id: ruleId("Actor-Actions-Heating6_3"),
    signalType: SignalTypes.Temperature_Current,
    functionNames: ["external sensor temp"],
    dpts: ["dpst-9-1"],
    manufacturers: ["m-0071"], // Zennio
  },
  {
    id: ruleId("Actor-Actions-Heating6_4"),
    signalType: SignalTypes.Temperature_ControlValue,
    functionNames: [/control var.*pi control/],
    dpts: ["dpst-5-1"],
    manufacturers: ["m-0071"], // Zennio
  },
  {
    id: ruleId("Actor-Actions-Zennio-switch"),
    signalType: SignalTypes.Switch,
    texts: ["on/off"],
    dpts: ["dpst-1-6"],
    manufacturers: ["m-0071"], // Zennio
  },
  {
    id: ruleId("Actor-Actions-RGB3_2"),
    signalType: SignalTypes.RGBRedSwitch,
    functionNames: ["colour red (switching)"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-RGB3_2"),
    signalType: SignalTypes.RGBRedStep,
    functionNames: ["relative dimming r", "dimming relative r", "colour red (dimming)"], //jung 3904EBLED
    dpts: ["dpst-3-7"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGB4"),
    signalType: SignalTypes.RGBRedValue,
    functionNames: ["absolute"], //AKD-0324V.02
    texts: ["red"], //AKD-0324V.02
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGB4_2"),
    signalType: SignalTypes.RGBRedValue,
    functionNames: ["absolute dimming r", "dimming absolute r", "colour red (value)"], //jung 3904EBLED
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGB10"),
    signalType: SignalTypes.RGBRedValue,
    texts: [/absolute.*red/], //VC-EASY.03
    dpts: ["dpst-5-1"], //VC-EASY.03
  },
  {
    id: ruleId("Actor-Actions-RGB11"),
    signalType: SignalTypes.RGBRedValue,
    functionNames: [/set.*rgb.*red/],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-RGB11_1"),
    signalType: SignalTypes.RGBRedValue,
    texts: [/rgb .*red/],
    functionNames: ["value"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-RGB5"),
    signalType: SignalTypes.RGBBlueSwitch,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["on/off"], //AKD-0324V.02
    texts: ["blue"], //AKD-0324V.02
    dpts: ["dpst-1-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGB5"),
    signalType: SignalTypes.RGBBlueSwitch,
    functionNames: ["colour blue (switching)"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-RGB6"),
    signalType: SignalTypes.RGBBlueStep,
    functionNames: ["relative"], //AKD-0324V.02
    texts: ["blue"], //AKD-0324V.02
    dpts: ["dpst-3-7"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGB3_8"),
    signalType: SignalTypes.RGBBlueStep,
    functionNames: ["relative dimming b", "dimming relative b", "colour blue (dimming)"], //jung 3904EBLED
    excludeFunctionNames: ["brightness"],
    dpts: ["dpst-3-7"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGB3_2_BES"),
    signalType: SignalTypes.RGBBlueStep,
    functionNames: ["dimming"],
    texts: ["blue"],
    dpts: ["dpst-3-7"],
    manufacturers: ["m-009e"], //Bes
  },
  {
    id: ruleId("Actor-Actions-RGB3_5_BES"),
    signalType: SignalTypes.RGBBlueValue,
    functionNames: ["value"],
    texts: ["blue"],
    dpts: ["dpst-5-1"],
    manufacturers: ["m-009e"], //Bes
  },
  {
    id: ruleId("Actor-Actions-RGB7"),
    signalType: SignalTypes.RGBBlueValue,
    functionNames: ["absolute"], //AKD-0324V.02
    texts: ["blue"], //AKD-0324V.02
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGB7_2"),
    signalType: SignalTypes.RGBBlueValue,
    functionNames: ["absolute dimming b", "dimming absolute b"], //jung 3904EBLED
    excludeFunctionNames: ["brightness"],
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGB10_4"),
    signalType: SignalTypes.RGBBlueValue,
    texts: [/absolute.*blue/], //VC-EASY.03
    dpts: ["dpst-5-1"], //VC-EASY.03
  },
  {
    id: ruleId("Actor-Actions-RGBb11"),
    signalType: SignalTypes.RGBBlueValue,
    functionNames: [/set.*rgb.*blue/, "colour blue (value)"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-RGB11_1"),
    signalType: SignalTypes.RGBBlueValue,
    texts: [/rgb .*blue/],
    functionNames: ["value"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-RGB8"),
    signalType: SignalTypes.RGBGreenSwitch,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["on/off"], //AKD-0324V.02
    texts: ["green"], //AKD-0324V.02
    dpts: ["dpst-1-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGB8_2"),
    signalType: SignalTypes.RGBGreenSwitch,
    functionNames: ["colour green (switching)"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-RGB9"),
    signalType: SignalTypes.RGBGreenStep,
    functionNames: ["relative"], //AKD-0324V.02
    texts: ["green"], //AKD-0324V.02
    dpts: ["dpst-3-7"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGB3_9"),
    signalType: SignalTypes.RGBGreenStep,
    functionNames: ["relative dimming g", "dimming relative g", "colour green (dimming)"], //jung 3904EBLED
    dpts: ["dpst-3-7"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGB3_3_BES"),
    signalType: SignalTypes.RGBGreenStep,
    functionNames: ["dimming"],
    texts: ["green"],
    dpts: ["dpst-3-7"],
    manufacturers: ["m-009e"], //Bes
  },
  {
    id: ruleId("Actor-Actions-RGB3_8_BES"),
    signalType: SignalTypes.RGBGreenValue,
    functionNames: ["value"],
    texts: ["green"],
    dpts: ["dpst-5-1"],
    manufacturers: ["m-009e"], //Bes
  },
  ////////////////////////////////////////////////////////
  {
    id: ruleId("Actor-Actions-RGB10_5"),
    signalType: SignalTypes.RGBGreenValue,
    functionNames: ["absolute"], //AKD-0324V.02
    texts: ["green"], //AKD-0324V.02
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGB10_6"),
    signalType: SignalTypes.RGBGreenValue,
    texts: [/absolute.*green/], //VC-EASY.03
    dpts: ["dpst-5-1"], //VC-EASY.03
  },
  {
    id: ruleId("Actor-Actions-RGB11_2"),
    signalType: SignalTypes.RGBGreenValue,
    functionNames: [/set.*rgb.*green/, "colour green (value)"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-RGB10_2"),
    signalType: SignalTypes.RGBGreenValue,
    functionNames: ["absolute dimming g", "dimming absolute g"], //jung 3904EBLED
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGB10_3"),
    signalType: SignalTypes.RGBGreenValue,
    texts: [/rgb .*green/],
    functionNames: ["value"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-RGBW5"),
    signalType: SignalTypes.RGBWhiteSwitch,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["on/off"], //AKD-0324V.02
    texts: ["white"], //AKD-0324V.02
    // excludeTexts: ["tw"], // AKD-0424R.02 no twswitch as signal type
    dpts: ["dpst-1-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGBW5_2"),
    signalType: SignalTypes.RGBWhiteSwitch,
    functionNames: ["colour white (switching)"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-RGBW6"),
    signalType: SignalTypes.RGBWhiteStep,
    functionNames: ["relative"], //AKD-0324V.02
    texts: ["white"], //AKD-0324V.02
    excludeTexts: ["cold", "warm"], // jung 3904EBLED
    dpts: ["dpst-3-7"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-RGB3_6_BES"),
    signalType: SignalTypes.RGBWhiteStep,
    functionNames: ["dimming"],
    texts: ["white"],
    dpts: ["dpst-3-7"],
    manufacturers: ["m-009e"], //Bes
  },
  {
    id: ruleId("Actor-Actions-RGB3_7_BES"),
    signalType: SignalTypes.RGBWhiteValue,
    functionNames: ["value"],
    texts: ["white"],
    dpts: ["dpst-5-1"],
    manufacturers: ["m-009e"], //Bes
  },
  {
    id: ruleId("Actor-Actions-RGBW3_3"),
    signalType: SignalTypes.RGBWhiteStep,
    functionNames: ["relative dimming white", "dimming relative white", "colour white (dimming)"], //jung 3904EBLED
    dpts: ["dpst-3-7"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Actions-RGBW7"),
    signalType: SignalTypes.RGBWhiteValue,
    functionNames: ["absolute"], //AKD-0324V.02
    texts: ["white"], //AKD-0324V.02
    excludeTexts: ["cold", "warm"], //jung 3904EBLED
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  // {
  //   id: ruleId("Actor-Actions-RGBW7_2"),
  //   signalType: SignalTypes.RGBWhiteValue,
  //   functionNames: ["absolute dimming white", "dimming absolute white"], //jung 3904EBLED
  //   dpts: ["dpst-5-1"], //jung 3904EBLED
  // },
  {
    id: ruleId("Actor-Actions-RGB10_3"),
    signalType: SignalTypes.RGBWhiteValue,
    texts: [/absolute.*white/, "colour white (value)"], //VC-EASY.03
    dpts: ["dpst-5-1"], //VC-EASY.03
  },
  {
    id: ruleId("Actor-Actions-RGB11_3"),
    signalType: SignalTypes.RGBWhiteValue,
    functionNames: [/set.*rgb.*white/],
    dpts: ["dpst-5-1"],
  },

  // Tuneable white
  {
    id: ruleId("Actor-Actions-TuneableWhite1"),
    signalType: SignalTypes.TWColdWhiteValue,
    texts: ["cw"], //AKD-0324V.02
    functionNames: ["absolutely"], //signalType: SignalTypes.ColorTemperatureKelvinValue,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    dpts: ["dpst-5-1"], // //AKD-0324V.02 // two different sizes ( 4 and 8 bytes)
  },

  {
    id: ruleId("Actor-Actions-TuneableWhite2"),
    signalType: SignalTypes.ColorTemperatureKelvin,
    dpts: ["dpst-7-600"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-TuneableWhite2_1"),
    signalType: SignalTypes.ColorTemperatureStep,
    texts: [/colour temperature fading/],
    functionNames: [/dim.*rel/],
    dpts: ["dpst-3-7"],
  },
  {
    id: ruleId("Actor-Actions-TuneableWhite3"),
    signalType: SignalTypes.TunableWhiteBrightnessTransition249_600,
    dpts: ["dpst-249-600"], // AKD-0324V.02 //Enertex 	1174-DK
  },

  {
    id: ruleId("Actor-Actions-TuneableWhite3_2"),
    signalType: SignalTypes.TunableWhiteTransitionStep,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    dpts: ["dpst-250-600"], // AKD-0324V.02 //Enertex 	1174-DK
  },
  {
    id: ruleId("Actor-Actions-TuneableWhite4"),
    signalType: SignalTypes.ColorTemperatureStep,
    functionNames: ["relatively"], //AKD-0324V.02
    texts: ["color"], //AKD-0324V.02
    dpts: ["dpst-3-7"], // AKD-0324V.02
  },
  {
    id: ruleId("Actor-Actions-TuneableWhite4_2"),
    signalType: SignalTypes.ColorTemperatureStep,
    functionNames: ["dim color temperature"], // Abb 	2CDG110274R0011
    dpts: ["dpst-3-7"],
  },

  {
    id: ruleId("Actor-Actions-TuneableWhite4_3"),
    signalType: SignalTypes.ColorTemperaturePercent,
    functionNames: [/color temperature.*percent/], // Enertex 	1174-DK
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-TuneableWhite4_4"),
    signalType: SignalTypes.ColorTemperaturePercent,
    texts: ["colour temperature relativ"],
    functionNames: ["value"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-TuneableWhite4_5"),
    signalType: SignalTypes.ColorTemperatureStep,
    texts: ["colour control fading"],
    functionNames: [/dim.*rel/],
    dpts: ["dpst-3-7"],
  },

  {
    id: ruleId("Actor-Actions-TuneableWhite5"),
    signalType: SignalTypes.TWColdWhiteValue,
    functionNames: ["abs. dimming cold", "absolute colour temperature"], //jung 3904EBLED //Enertex 	1174-DK
    excludeFunctionNames: ["WW", "warm"], ////Enertex 	1174-DK
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },

  {
    id: ruleId("Actor-Actions-TuneableWhite6"),
    signalType: SignalTypes.ColorTemperatureStep,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["rel. dimming cold", "relative colour temperature"], //jung 3904EBLED ////Enertex 	1174-DK
    excludeFunctionNames: ["WW", "warm"], ////Enertex 	1174-DK
    dpts: ["dpst-3-7"], //jung 3904EBLED
  },

  /// dimm
  {
    id: ruleId("Actor-Actions-Dimmer1"),
    signalType: SignalTypes.DimStep,
    functionNames: ["dim", "change", "relative", /brighter.*darker/], //AKD-0203.01
    excludeFunctionNames: ["absolute", "hsv", "hue", "saturation", "color"],
    excludeTexts: ["(red", " red", "green", "blue", "white", "hue", "saturation"], // rgb
    dpts: ["dpst-3-7"], //AKD-0203.01
  },
  /// dimm

  {
    id: ruleId("Actor-Actions-Dimmer3"),
    signalType: SignalTypes.DimStep,
    functionNames: ["input"], //
    texts: ["relative", "dim"], // //
    dpts: ["dpst-3-7"], //
  },
  {
    id: ruleId("Actor-Actions-Dimmer4"),
    signalType: SignalTypes.DimValue,
    functionNames: ["dim", "0%", "brightness", "absolute"], // AKD-0424R2.02  ||| //AKD-0203.01 // // //AKD-0203.01
    excludeFunctionNames: ["switch"], // AKD-0201.02, 18: Switch-On value (0% = Parameter)
    excludeTexts: ["hue", "saturation"],
    dpts: ["dpst-5-1", "dpst-5-3"], //AKD-0203.01 //   ////
  },
  {
    id: ruleId("Actor-Actions-Dimmer4_2"),
    signalType: SignalTypes.DimValue,
    functionNames: ["brightness value"], //jung 3210UP
    dpts: ["@ 1 byte"], //jung 3210UP
  },
  {
    id: ruleId("Actor-Actions-Dimmer5"),
    signalType: SignalTypes.DimValue,
    functionNames: ["input"], //
    texts: ["value"], //
    dpts: ["dpst-5-1"], //
  },
  {
    id: ruleId("Actor-Actions-Dimmer6"),
    signalType: SignalTypes.DimStep,
    functionNames: ["dim"], // gira  2165 00, Jalousie up, Eingang 20BD11
    dpts: ["@ 4 bit"],
  },
  {
    id: ruleId("Actor-Actions-Dimming7"),
    signalType: SignalTypes.DimStep,
    texts: ["dimming"],
    dpts: ["dpst-3-7"],
  },

  {
    id: ruleId("Actor-Actions-WinterSummer-1"),
    signalType: SignalTypes.WinterSummer,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    texts: ["winter", "summer"], //
    excludeTexts: ["garten"],
    dpts: ["dpst-1-1"], //
  },

  // switch
  {
    id: ruleId("Actor-Actions-Switch1"),
    signalType: SignalTypes.StaircaseLight,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["staircase"], //AKD-0203.01 AKD-0324V.02 AKD-0324V.02
    dpts: ["dpst-1-1", "dpst-1-3"], // AKD-0203.01AKD-0324V.02 AKD-0324V.02 // ABB 2CDG 110 079 R0011
  },
  {
    id: ruleId("Actor-Actions-Switch1_2"),
    signalType: SignalTypes.StaircaseLight,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["timer"], //TXA207A - a2 Hager M-0009
    dpts: ["dpst-1-1"], // TXA207A - a2 Hager M-0009
    manufacturers: ["m-0009"], //Hager M-0009
  },
  {
    id: ruleId("Actor-Actions-Switch2_P"),
    signalType: SignalTypes.Pulse,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["pulse"], // //
    dpts: ["dpst-1-1"], //
  },
  {
    id: ruleId("Actor-Actions-Switch2"),
    signalType: SignalTypes.Switch,
    functionNames: ["switch", "toggle"], // //
    excludeTexts: ["relay"], //abb 2CDG 110 222 R0011
    dpts: ["dpst-1-1"], //
  },

  // Lock
  {
    id: ruleId("Actor-Actions-Lock2-Ignored"), // Disable Lock2 for MDT Dimmer, because it distubs channel detection
    signalType: SignalTypes.Ignored,
    functionNames: ["lock ii", "block ii", "lock 2"], //
    dpts: ["dpst-1-1", "dpst-1-3", "dpst-1-11"],
  },

  // Lock
  {
    id: ruleId("Actor-Actions-Lock1"),
    signalType: SignalTypes.Lock,
    // ⚠ ONLY-HERE: nicht in Button/Actions
    functionNames: ["lock", "block", "jamming", "inhibit"], // // // jamming for hager TXA207A - a2
    excludeFunctionNames: ["manual"], //abb 2CDG 110 245 R0011
    dpts: ["dpst-1-1", "dpst-1-3", "dpst-1-11"],
  },
  {
    id: ruleId("Actor-Actions-Lock2"),
    signalType: SignalTypes.Lock,
    texts: ["inhibit"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-Lock1"),
    signalType: SignalTypes.Lock,
    texts: ["inhibit"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-Switch3"),
    signalType: SignalTypes.Switch, //_Switch /Staircase light
    excludeFunctionNames: [
      "alarm",
      "scene",
      "stop",
      "pump",
      "error",
      "warn",
      "reset",
      "logic",
      "lock", //jung 3904EBLED
    ], // //AKD-0324V.02 // // //
    excludeTexts: ["relay", "indication"], //abb 2CDG 110 222 R0011 // hager TX206H
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Actions-Switch4"),
    signalType: SignalTypes.Ignored,
    functionNames: ["threshold"], // AKD-0424R2.02 Channel D Nr54 block 1|| //
    dpts: ["dpst-5-1", "dpst-5-5", "dpst-7-1", "dpst-9-1", "dpst-9-4"], // // // // // //// two different sizes (8 and 16 bytes)
  },

  // Scene

  {
    id: ruleId("Actor-Actions-Scene2"),
    signalType: SignalTypes.Scene,
    dpts: ["dpst-17-1", "dpst-18-1"], //AKD-0324V.02 //
  },

  // for ABB, SD/S4.16.1 Switch/Dim Actor, 4-fold, MDRC
  {
    id: ruleId("Actor-Actions-Scene3"),
    signalType: SignalTypes.Scene,
    functionNames: ["scene", "szene"], //
    objectSize: "1 byte",
  },

  {
    id: ruleId("Actor-Actions-Scene4"),
    signalType: SignalTypes.Scene,
    functionNames: ["scene"], //
    dpts: ["@ 1 byte"],
  },

  // Time & Date
  {
    id: ruleId("Actor-Actions-DateTime1"),
    signalType: SignalTypes.DateTime,
    functionNames: ["input", "receive"], // //
    dpts: ["dpst-19-1"], //
  },
  {
    id: ruleId("Actor-Actions-DateTime2"),
    signalType: SignalTypes.DateTime,
    texts: ["date/time"], //
    dpts: ["dpst-19-1"], //
  },
  {
    id: ruleId("Actor-Actions-DateTime3_hrs"),
    signalType: SignalTypes.Time,
    functionNames: ["time", "receive", "hours"], //AKS-0810.03 // //AKI-0416.04
    dpts: ["dpst-10-1"], // //AKS-0810.03 //
  },
  {
    id: ruleId("Actor-Actions-DateTime3_hrs55"),
    signalType: SignalTypes.TimeHrs55,
    functionNames: ["time", "receive", "hours"], //AKS-0810.03 // //AKI-0416.04
    dpts: ["dpst-5-5"], // //AKS-0810.03 //
  },
  {
    id: ruleId("Actor-Actions-DateTime3_sec"),
    signalType: SignalTypes.Ignored,
    functionNames: ["time", "receive"], //AKS-0810.03
    dpts: ["dpst-13-100"], //AKI-0416.04
  },
  {
    id: ruleId("Actor-Actions-DateTime4"),
    signalType: SignalTypes.Time,
    texts: ["time"], //
    excludeTexts: ["dimm"], //2CKA006197A0061 flexieble dimm zeit
    dpts: ["dpst-10-1"], ///
  },
  {
    id: ruleId("Actor-Actions-DateTime5"),
    signalType: SignalTypes.Date,
    functionNames: ["receive"], //
    dpts: ["dpst-11-1"], //
  },
  {
    id: ruleId("Actor-Actions-DateTime6"),
    signalType: SignalTypes.Date,
    texts: ["date"], //
    dpts: ["dpst-11-1"], //
  },

  {
    id: ruleId("Actor-Actions-DateTime7"),
    signalType: SignalTypes.DayNight,
    functionNames: ["day", "night"], // //
    dpts: ["dpst-1-2"], //
  },
  {
    id: ruleId("Actor-Actions-DateTime8"),
    signalType: SignalTypes.DayNight,
    texts: ["day", "night"], // //
    dpts: ["dpst-1-2"], //
  },
  // Forced Control
  {
    id: ruleId("Actor-Actions-ForcedControl1"),
    signalType: SignalTypes.ForcedControl,
    functionNames: ["control", "forced pos", "disabling"], // // //
    dpts: ["dpst-2-1"], // // //
  },
  // Logic
  {
    id: ruleId("Actor-Actions-Logic1"),
    signalType: SignalTypes.Switch,
    functionNames: ["logic"], //
    dpts: ["dpst-1-2", "dpst-1-1"], // //1057 00
  },

  {
    id: ruleId("Actor-Actions-SelectMode1"),
    signalType: SignalTypes.OperationMode,
    excludeTexts: ["output"], //
    excludeFunctionNames: ["forced", "currently"],
    dpts: ["dpst-20-102"], //
  },
  {
    id: ruleId("Actor-Actions-SelectMode1"),
    signalType: SignalTypes.OperationMode,
    excludeTexts: ["output"], //
    excludeFunctionNames: ["forced", "currently"],
    dpts: ["dpst-20-102"], //
  },

  // to catch all undefined signals on dpts 1-1
  {
    id: ruleId("Actor-Actions-Switch5"),
    signalType: SignalTypes.Switch,
    excludeTexts: ["relay", "indication", "manual operation"], //abb 2CDG 110 222 R0011 //hager TX206H // abb 2CDG 110 248 R0011
    excludeFunctionNames: ["hours"], // merten MEG6730-0001
    dpts: ["dpst-1-1", "dpst-1-17"], //
  },
];

export const actorActionsSensitiv: Array<NameListEntry> = [
  // {
  //   id: ruleId("Actor-Actions-sensitiv-heating5-Merten"),
  //   channelType: [ChannelType.Heating],
  //   oldSignalType: SignalTypes.Unknown,
  //   signalType: SignalTypes.Temperature_Current,
  //   texts: ["current"],
  //   dpts: ["@ 1 byte"],
  //   // ⚠ DPT-SIZE: "@ 1 byte" is 8 bit (expected 16 bit for SignalTypes.Temperature_Current)
  //   manufacturers: ["m-000c", "m-0064"],
  // },// wo?????????????
  {
    id: ruleId("Actor-Actions-sensitiv-Dimming1"),
    channelType: [ChannelType.Dimmer],
    oldSignalType: SignalTypes.Unknown,
    signalType: SignalTypes.DimValue,
    functionNames: ["value"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-sensitiv-RGB11_4"),
    channelType: [ChannelType.Rgb],
    oldSignalType: SignalTypes.RGBWhiteValueStatus,
    signalType: SignalTypes.RGBWhiteValue,
    texts: [/colour .*white/],
    functionNames: ["value"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-sensitive-blind8"),
    signalType: SignalTypes.BlindSingleObjectControl,
    channelType: [ChannelType.Blind, ChannelType.Jalousie],
    functionNames: [/single obj.*control/],
    dpts: ["dpst-1-8"],
  },
  {
    id: ruleId("Actor-Actions-sensitive-Dimming8"),
    signalType: SignalTypes.DimValue,
    channelType: [ChannelType.Dimmer],
    texts: ["value"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Actions-sensitive-DimRemessure"),
    channelType: [ChannelType.Dimmer],
    signalType: SignalTypes.DimRemessure,
    functionNames: ["re-measure"],
    dpts: ["dpst-1-10"],
  },
];
